<div class="flex flex-column justify-content-center align-items-center min-h-screen min-w-screen overflow-hidden surface-ground">
  <div class="max-w-md m-auto">
    <div class="p-8 text-center">
      <div class="error-code">403</div>
      <h1 class="text-4xl font-bold text-900 mb-2">Access Denied</h1>
      <p class="text-600 mb-6">You do not have permission to view this page.</p>
      <button pButton pRipple type="button" label="Go to Dashboard" class="p-button-text" routerLink="/"></button>
    </div>
  </div>
</div>
